<template>
  <div>

    <div class="notice-card">
      <div class="notice-card_header">
        <span class="circle" :class="(notice.status? 'green':'red')"></span>
        <span class="notice-card_header_name">{{notice.name}}</span>
        <span class="mdi mdi-border-color pen" @click="edit(notice)"></span>
      </div>
      <div class="notice-card_content">

        <div class="notice-card_content content-item" v-if="notice.owner === false">
          <div class="left">
            <span class="title">{{this.translate('notification.item.owner')}}:</span>
          </div>
          <div class="right">
            <span class="title">{{notice.username}}:{{notice.clientname}}:</span>
            
          </div>
        </div>

        <div class="notice-card_content_channels content-item">
          <div class="left">
            <span class="title">{{this.translate('notification.item.channels')}}:</span>
          </div>
          <div class="right">
            <div class="item" v-for="(channel,key) in notice.sendto" :key="key">
              <i v-if="channel_type(channel)==='telegram'" :title="channel_name(channel)" class="mdi mdi-telegram"/>
              <i v-if="channel_type(channel)==='email'" :title="channel_name(channel)" class="mdi mdi-at"/>
            </div>
          </div>
        </div>

        <div class="notice-card_content_watched content-item">
          <div class="left">
            <span class="title">{{this.translate('notification.item.watch')}}:</span>
          </div>
          <div class="right">
            <div class="item">
              <hidden-list-notif :list="notice.devices" type_list="dev" v-if="notice.devices" type="html">
                <span slot="title">{{this.translate('notification.item.devices')}}:</span>
                <span slot="cnt">{{count(notice.devices)}}</span>
              </hidden-list-notif>

              <hidden-list-notif :list="notice.groups" type_list="group" v-if="notice.groups" type="other">
                <span slot="title">{{this.translate('notification.item.groups')}}:</span>
                <span slot="cnt">{{count(notice.groups)}}</span>
              </hidden-list-notif>
            </div>
          </div>
        </div>

        <div class="notice-card_content_triggers content-item">
          <div class="left">
            <span class="title">{{this.translate('notification.item.list')}}:</span>
          </div>
          <div class="right">
            <div class="item">
              <hidden-list-notif :list="notice_triggers_list" :type_list="'trigger'" v-if="notice.triggers">
                <span slot="title">{{this.translate('notification.item.triggers')}}:</span>
                <span slot="cnt">{{count(notice.triggers)}}</span>
              </hidden-list-notif>
            </div>
          </div>
        </div>

      </div>
      <div class="notice-card_footer">
        <span class="btn btn-danger" @click="pred_del_notice(notice.id)">{{this.translate('notification.delete')}}</span>
      </div>
    </div>

  </div>
</template>

<script>
import HiddenListNotif from "@/components/UIComponents/List/hiddenlistNotif"
import NotificationEdit from "./NotificationEdit";
import NotificationDelete from "./NotificationDelete";

export default {
  name: "NotificationItem",
  components: {
    HiddenListNotif
  },
  props: ['notice', 'channels_list','triggers_list'],
  data () {
    return {
    }
  },
  mounted () {
  },
  methods: {
    count(array){
      return array.length
    },
    channel_name(channel){
      for (let ch in this.channels_list) {
        if (this.channels_list[ch].id === channel.channel_id) {
          return this.channels_list[ch].name
        }
      }
    },
    channel_type(channel){
      for (let ch in this.channels_list) {
        if (this.channels_list[ch].id === channel.channel_id) {
          return this.channels_list[ch].type
        }
      }
    },
    pred_del_notice(id){
      let t = this.$createElement(NotificationDelete, {
        props: {
          notice_id: id
        },
        on: {
          close: () => {this.$modal.hide('dynamic-modal') },
          reload: () => {this.reload()}
        }
      })
      let temp = {
        render () { return t }
      }
      this.$modal.show(temp, {}, {height: 'auto',  width: 800, adaptive: true, clickToClose: true, scrollable: true, name: 'dynamic-modal'})

    },
    reload(){
      this.$emit('reload')
    },
    check_group(parent, group, id, devs_ids, groups_for_dev_ids, groups_ids, groups_for_grp_ids){
      let new_group = {
        id: +group.id,
        expanded: false,
        hasExpanded: true,
        parent: group.parent,
        name: group.name,
        children: [],
        role: 'group'
      }
      if(groups_ids.indexOf(+group.id) > -1){
        new_group.checked = true
        new_group.children.push({ role: 'empty', visible: false, checked: true })
      }else{
        new_group.checked = false
        new_group.children.push({ role: 'empty', visible: false })
      }

      parent.children[id] = new_group

      if (groups_for_dev_ids.indexOf(parent.children[id].id) > -1 || groups_for_grp_ids.indexOf(parent.children[id].id) > -1) {
        parent.children[id].expanded = true
        this.$http.v1.getListDevicesByIdGroup({group_id: group.id}, (response) => {
          let devices = response.data
          for(let j in devices) {
            let device = {
              name: '(' + devices[j].fid + ') ' + '<b>' + devices[j].name2 + '</b>',
              id: devices[j].device_id,
              role: 'children',
              group_id: +group.id,
              fid: devices[j].fid
            }
            devs_ids.indexOf(+devices[j].device_id) > -1 ? device.checked = true : device.checked = false

            parent.children[id].children.push(device)
          }
        })
      }

      if (group.children) {
        for(let children_id in group.children) {
          this.check_group(parent.children[id], group.children[children_id], children_id, devs_ids, groups_for_dev_ids, groups_ids, groups_for_grp_ids);
        }
      }

    },
    edit (notice) {

      let devs_ids = []
      let groups_for_dev_ids = []

      if(notice.devices) {
        for (let nd in notice.devices) {
          devs_ids.push(notice.devices[nd].id)
          groups_for_dev_ids = groups_for_dev_ids.concat(notice.devices[nd].group_id)
          groups_for_dev_ids = groups_for_dev_ids.concat(...this.$store.getters.getPathGroupById(notice.devices[nd].group_id))
        }
      }

      let groups_ids = []
      let groups_for_grp_ids = []

      if(notice.groups) {
        for (let ng in notice.groups) {
          groups_ids.push(notice.groups[ng].id)
          groups_for_grp_ids = groups_for_grp_ids.concat(this.$store.getters.getPathGroupById(notice.groups[ng].id))
        }
      }

      groups_for_dev_ids = [ ...new Set(groups_for_dev_ids) ]

      let groups = this.$store.getters.getDeviceGroupsTree

      let group_list = {children: []}
      for(let group_id in groups) {
        this.check_group(group_list, groups[group_id], group_id, devs_ids, groups_for_dev_ids, groups_ids, groups_for_grp_ids);
      }

      let t = this.$createElement(NotificationEdit, {
        props: {
          notice,
          channels_list: this.channels_list,
          list_devices: group_list.children
        },
        on: {
          close: () => {this.$modal.hide('dynamic-modal') },
          reload: () => {this.reload()}
        }
      })
      let temp = {
        render () { return t }
      }
      this.$modal.show(temp, {}, {height: 'auto',  width: 800, adaptive: true, clickToClose: true, scrollable: true, name: 'dynamic-modal'})
    }

  },
  computed: {
    notice_triggers_list() {
      let triggers = this.notice.triggers
      let list = this.triggers_list
      for (let tr in triggers) {
        for (let l in list) {
          if (list[l].id === triggers[tr].definition_id) {
            let params = JSON.parse(list[l].ui_params)
            if(this.$data.language === "ru" && params.name_ru) {
              triggers[tr].name = params.name_ru
            }else if (this.$data.language === "en" && params.name_en) {
              triggers[tr].name = params.name_en
            }else{
              triggers[tr].name = list[l].name
            }

          }
        }
      }
      return triggers
    }
  }
}
</script>

<style lang="scss">

  .notice-card {
    border-radius: 10px;
    box-shadow: 0 2px 2px #ccc5b980;
    color: #252422;
    padding-bottom: 10px;
    position: relative;
    border: 1px solid #ccc;
    min-height: 85px;
    background-color: #f8f8f8;
    &_header{
      font: 300 1.41rem/1.95rem "Roboto", Arial, sans-serif;
      text-transform: uppercase;
      color: #000;
      background: #f4f3ef;
      padding: 1rem 2rem;
      border-radius: 0.85rem 0.85rem 0 0;
      display: flex;
      align-items: center;
      justify-content: space-between;
      &_name {
        text-transform: none;
        font-size: 12px;
        padding: 0 0.3rem 0 0.75rem;
      }
      .circle{
        height: 15px;
        width: 15px;
        border-radius: 50%;
        text-align: center;
        vertical-align: middle;
        margin: 0;
        &.green{
          background-color: #1db328;
        }
        &.red{
          background-color: red;
        }
      }
      .pen{
        transition: 0.2s;
        &:hover{
          color: #41B883;
        }
      }
    }
    &_content {
      font: 300 1.15rem/1.5rem "Roboto", Arial, sans-serif;
      text-align: center;
      .list {
        overflow: auto;
        max-height: 13rem;
        &_item {
          display: flex;
          justify-content: space-between;
          flex-direction: row;
          border-bottom: 1px dotted #ddd;
          background: #fff;
          margin: 0.5rem 2.15rem 0.5rem 0;
          position: relative;
        }
      }
      .content-item{
        display: flex;
        justify-content: center;
        align-items: flex-start;
        padding: 5px;
        &>div{
          width: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 12px;
          height: 100%;
          i{
            font-size: 20px;
            transition: 0.2s;
            &:hover{
              color: #41B883
            }
          }
        }
        &:nth-child(2n){
        }
        &:nth-child(2n+1){
          background-color: #e2ecdc;
        }
      }
      &_watched{
        height: 50px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
    &_footer {
      text-align: center;
      margin: 1.5rem 0 2rem;
    }

  }

</style>
